export enum TipoCargaDatosEnum {
	CargaPreciosGeneral = 1,
	CargaVolumen = 2,
}
